import { Component, Input, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MktTaggingTransformationService } from 'src/app/core/services';
import { getBrowserNameForTagging } from '../../utility/browser-util';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'app-citi-shop-add-to-browser-button',
  templateUrl: './citi-shop-add-to-browser-button.component.html',
  styleUrls: ['./citi-shop-add-to-browser-button.component.scss'],
  standalone: false
})
export class CitiShopAddToBrowserButtonComponent implements AfterViewInit {

  @Input() sectionName: string = '';
  @Input() buttonColor: 'blue' | 'white' = 'blue';
  @Output() buttonClicked = new EventEmitter<boolean>();
  @ViewChild('downloadBtn') downloadBtn: ElementRef;

  constructor(
    private _mktTaggingTransformationService: MktTaggingTransformationService,
    public csp: CitiShopPropsService
    ){}

  ngAfterViewInit(): void {
    this.disableDownloadBtn();
  }

  onAddToDownloadBtnClick() {
    this._addToDownloadBtnTagging(this.csp.addToBrowserBtnLbl() ? this.csp.addToBrowserBtnLbl() : this.csp.downloadNowBtnLbl());
    this.buttonClicked.emit(true);
  }

  private _addToDownloadBtnTagging(btnName: string) {
    const tagObj = {
      'link_name': `${this.transform(this.sectionName)}|${btnName}`,
      'form_type': getBrowserNameForTagging(),
    }
    this._mktTaggingTransformationService.tagMktCompareCards('citishop_landing_ctaclicked', tagObj)
  }

  private transform(str: string): any {
      str = str.replace(/®/g, '');
      str = str.replace(/\//g, '');
      str = str.replace(/™/g, '');
      str = str.replace(/\+/g, '');
      str = str.replace(/<sup>/g, '');
      str = str.replace(/<\/sup>/g, '');
      str = str.replace(/<sub>/g, '');
      str = str.replace(/<\/sub>/g, '');
      str = str.replace(/&#126;/g, '~');
      str = str.replace(/\<br\>/g, ' ');
      return str;
  }

  private disableDownloadBtn(): void{
    if(this.csp?.isSuspendDialogEnable()) {
        const btn = (this.downloadBtn?.nativeElement) as HTMLButtonElement;
        btn && (btn.disabled = true);
      }
  }

}
